import { render } from "./WaitSkeleton.vue?vue&type=template&id=78d4f556"
import script from "./WaitSkeleton.vue?vue&type=script&lang=js"
export * from "./WaitSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__